<template>
  <manual-notifications
    :is-loading="isLoading"
    :notification-templates="notificationTemplates"
    :has-notification-template-access="hasNotificationTemplateAccess"
    :language="account.language"
    :key="isVisible"
    @send-notification="onSendNotification"
    @cancel="$emit('close')"
  />
</template>

<script>
import { API } from '@/utils/api'
import { ManualNotifications } from '../'
const NOTIFICATION_TEMPLATES = '/$v/notification-center/events/list.json'
const NOTIFICATION_SEND = '/$v/notification-center/notification/notify.json'

export default {
  components: {
    ManualNotifications
  },
  props: {
    isVisible: Boolean,
    hasNotificationTemplateAccess: Boolean,
    account: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      notificationTemplates: [],
      isLoading: false,
    }
  },
  methods: {
    initialize () {
      if (this.hasNotificationTemplateAccess) {
        this.isLoading = true
        this.loadTemplates().finally(() => this.isLoading = false)
      }
    },

    loadTemplates () {
      return API.call(NOTIFICATION_TEMPLATES, {
        login: this.account.login,
        event: {
          status: 'active'
        }
      }).then(r => this.notificationTemplates = r.data)
    },

    onSendNotification (message) {
      this.isLoading = true
      return API.call(NOTIFICATION_SEND, {
        login: this.account.login,
        account_id: this.account.account_id,
        message
      })
        .then(() => this.$emit('close'))
        .finally(() => this.isLoading = false)
    }
  },

  mounted () {
    this.initialize()
  },

  watch: {
    isVisible (val) {
      if (val) {
        this.initialize()
      }
    }
  }
}
</script>
